import api from '@/api'
import { formatDate } from '@/utils'

const trafficStore = {
  state: {
    stats: {
      traffic7DaysCount: 0,
      traffic30DaysCount: 0,
      trafficTotalCount: 0
    },
    chartData: {
      series: [],
      tooltip: {
        formatter (params) {
          const data = params[0]
          return `
            <div style="padding: 0 10px;color: #666;">
              <div>${data.name}</div>
              <div style="font-size: 12px;">
                <div><span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${data.color};"></span>${data.seriesName}：${data.value[1]}</div>
              </div>
            </div>
          `
        }
      }
    },
    detail: {
      total: 0,
      list: []
    }
  },

  mutations: {
    SET_TRAFFIC_STATS (state, { trafficLast7Days, trafficLast30Days, finished }) {
      state.stats.traffic7DaysCount = trafficLast7Days || 0
      state.stats.traffic30DaysCount = trafficLast30Days || 0
      state.stats.trafficTotalCount = finished || 0
    },

    SET_TRAFFIC_CHART_DATA (state, { chartData }) {
      state.chartData.series = chartData.series
    },

    SET_TRAFFIC_DETAIL (state, { total, trafficDetailList }) {
      state.detail.total = total
      state.detail.list = trafficDetailList
    }
  },

  actions: {
    getTrafficStats ({ commit }, data) {
      return api.traffic.getTrafficStats(data).then(response => {
        commit('SET_TRAFFIC_STATS', response.data)
        return response
      })
    },

    getTrafficChartData ({ commit }, data) {
      return api.traffic.getTrafficChartData(data).then(response => {
        const data = response.data.trafficSummaryList
        const line = {
          name: '流量',
          type: 'line',
          data: [],
          itemStyle: {
            normal: {
              color: '#2a85ff',
              lineStyle: {
                color: '#2a85ff',
                width: 2
              }
            }
          }
        }

        data.forEach(item => {
          const date = formatDate(item.datetime, 'YYYY-MM-DD', 's')
          const trafficCount = item.trafficCount
          line.data.push([ date, trafficCount ])
        })

        commit('SET_TRAFFIC_CHART_DATA', { chartData: { series: [ line ] } })
        return response
      })
    },

    getTrafficDetail ({ commit }, data) {
      return api.traffic.getTrafficDetail(data).then(response => {
        commit('SET_TRAFFIC_DETAIL', response.data)
        return response
      })
    }
  }
}

export default trafficStore
